import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/opt/build/repo/layouts/blank.vue").then(m => m.default || m)),
  board: defineAsyncComponent(() => import("/opt/build/repo/layouts/board.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m))
}